import { DSTextarea } from '@vr/ds-react'
import { Controller } from 'react-hook-form'

import { ObservationsProps } from './type'

export const Observations = ({ methods, accountKey }: ObservationsProps) => {
  return (
    <Controller
      key={accountKey}
      name='observacoes'
      control={methods.control}
      render={({ field: { onChange, value } }) => (
        <DSTextarea
          disableResize
          label='Observações'
          maxLength={256}
          onChange={onChange}
          placeholder='Observações'
          value={value}
        />
      )}
    />
  )
}
